import { Text } from "@/components/ui/text";
import { useAuth } from "@/contexts/AuthContext";
import { Bug } from "@/icons/Bug";
import { MessageCircle } from "@/icons/MessageCircle";
import { Sparkle } from "@/icons/Sparkle";
import { User } from "@/icons/User";
import { Users } from "@/icons/Users";
import { cn } from "@/utils/cn";
import { DrawerContentScrollView } from "@react-navigation/drawer";
import { Link } from "expo-router";
import type { LucideIcon } from "lucide-react-native";
import { Image, Platform, StyleSheet, View } from "react-native";

const LOGO = require("../assets/images/logo-transparent-dark.png");

export function DrawerContent() {
  const { user } = useAuth();
  return (
    <DrawerContentScrollView
      style={styles.scrollView}
      contentContainerStyle={styles.container}
    >
      <Image source={LOGO} style={styles.logo} resizeMode="contain" />

      <View className="flex flex-1 flex-col justify-between">
        <View>
          <ListItem href="/chat" title="Chat" Icon={MessageCircle} />
          <ListItem href="/persona" title="Personas" Icon={Users} />
          <ListItem href="/account" title="Account" Icon={User} />
        </View>
        <View>
          {user?.planKeyname === "free" && (
            <ListItem
              href="/upgrade"
              title="Upgrade"
              Icon={Sparkle}
              highlight
            />
          )}
          <ListItem href="/feedback" title="Send Feedback" Icon={Bug} />
        </View>
      </View>
    </DrawerContentScrollView>
  );
}

function ListItem({
  href,
  title,
  Icon,
  highlight = false,
}: {
  href: Parameters<typeof Link>["0"]["href"];
  title: string;
  Icon: LucideIcon;
  highlight?: boolean;
}) {
  return (
    <Link href={href}>
      <View
        className={cn(
          "flex flex-row items-center p-4",
          highlight ? "rounded-full bg-gray-800" : "",
        )}
      >
        <Icon color="#fff" className="w-8" />
        <Text className="native:font-bold pl-4">{title}</Text>
      </View>
    </Link>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    backgroundColor: "#0f1313",
    borderTopRightRadius: Platform.OS === "web" ? 0 : 16,
    borderBottomRightRadius: Platform.OS === "web" ? 0 : 16,
  },
  container: {
    flexGrow: 1,
  },
  logo: {
    width: 150,
    marginLeft: 16,
  },
});
